import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { NFeatures } from '../interfaces/services/features.interfaces'
import axiosAuth from './config'
import { createUrl } from './helpers'

const getFeatures = async (): Promise<
  AxiosResponse<NFeatures.NGetFeatures.IResponse>
> => {
  return axiosAuth.get<NFeatures.NGetFeatures.IResponse>(createUrl(`/features`))
}

export const featureQueries = {
  getFeatures: () =>
    queryOptions({
      queryKey: [{ scope: 'features', entity: 'getFeatures' }],
      queryFn: async () => {
        return (await getFeatures()).data.data
      },
    }),
}
